import React from "react";

export type SettingsHeaderContextValue = {
    hostElement: HTMLElement | null
    isMobile: boolean
    contentScrolled: boolean
}

export const SettingsHeaderContext = React.createContext<SettingsHeaderContextValue | null>(null)

export const useSettingsHeaderContext = () => {
    const context = React.useContext(SettingsHeaderContext)
    if (!context) throw new Error('Settings headers must be rendered inside SettingsLayout')
    return context
}
